// extracted by mini-css-extract-plugin
export default {"spinner":"Preloader_spinner__1Aon0","animate":"Preloader_animate__GX9Ff"};